import { useEffect } from 'react';

/**
 * Hook to set the window title for a page
 * Usage: usePageTitle('Downloads') sets title to 'TerraSciencesPortal - Downloads'
 */
export const usePageTitle = (pageName: string) => {
  useEffect(() => {
    document.title = `TerraSciencesPortal - ${pageName}`;
  }, [pageName]);
};
